import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../../lib/api";
import { ChevronRight, MapPin, Phone } from "lucide-react";
import ContactForm from "../../components/public/ContactForm";
import ServicesSection from "../../components/public/ServicesSection";
import { useSettings } from "../../lib/useSettings";

export default function ZonePage() {
  const { slug } = useParams();
  const [z, setZ] = useState(null);
  const { settings: s } = useSettings();
  useEffect(() => { api.get(`/zones/${slug}`).then(r => setZ(r.data)).catch(()=>setZ(false)); }, [slug]);
  if (z === false) return <div className="py-24 text-center">Zone introuvable.</div>;
  if (!z) return <div className="py-24 text-center">Chargement...</div>;
  return (
    <>
      <title>{z.meta_title}</title>
      <meta name="description" content={z.meta_description}/>
      <section className="pt-14 pb-16 bg-[color:var(--brand-navy)] text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <nav className="text-xs text-white/60 mb-4 flex items-center gap-2"><Link to="/">Accueil</Link><ChevronRight className="w-3 h-3"/>Zones<ChevronRight className="w-3 h-3"/>{z.city}</nav>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 text-xs font-bold uppercase mb-3"><MapPin className="w-3 h-3"/> {z.postal_code}</div>
          <h1 className="font-display text-4xl md:text-6xl font-black">Plombier & Climaticien à {z.city}</h1>
          <p className="mt-4 text-white/85 text-lg max-w-3xl">{z.content}</p>
          {s?.phone && <a href={`tel:${s.phone.replace(/\s/g,"")}`} className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[color:var(--brand-red)] text-white font-bold">
            <Phone className="w-4 h-4"/> {s.phone}
          </a>}
        </div>
      </section>
      <ServicesSection onlyFeatured={true} title={`Nos services à ${z.city}`} subtitle="Climatisation · Plomberie · Dépannage"/>
      <section className="py-14">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <ContactForm title={`Demande à ${z.city}`} description="Étude gratuite et devis personnalisé sous 24h."/>
        </div>
      </section>
    </>
  );
}
